import { Component } from 'react';
import { connect } from 'react-redux';
import api from 'api';
import { breakpoints } from 'styles';
import { getFormattedDate } from 'lib/common';
import { Avatar, EmptyIndicator, Owners } from 'components/common';
import {
  Box,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import { CourseTitleWithInfo } from 'components/courses/common';

const AnalyticsCoursesMostPopular = connect((state) => state)(
  class extends Component {
    state = { courses: null, loading: false };

    componentDidMount() {
      this.updateData();
    }

    componentDidUpdate(prevProps) {
      const { fromDate, toDate } = this.props;
      if (fromDate !== prevProps.fromDate || toDate !== prevProps.toDate) {
        this.updateData();
      }
    }

    updateData = async () => {
      try {
        this.setState({ loading: true });
        const { fromDate, toDate } = this.props;
        const response = await api.get(
          `/admin/analytics/most-accessed-courses` +
            `?fromDate=${fromDate}` +
            `&toDate=${toDate}`
        );
        this.setState({ courses: response.data.courses, loading: false });
      } catch (err) {
        this.setState({ loading: false });
        await this.props.dispatch.handleErrorDispatch(err);
      }
    };

    render() {
      const { fromDate, toDate, messages, theme } = this.props;
      const { courses, loading } = this.state;

      return (
        <div className="courses">
          <Box
            loading={loading}
            padding={0}
            title={messages.analyticsMostPopularCourses}
            headerContent={
              <div className="date">
                {`${getFormattedDate({ date: fromDate })} - ${getFormattedDate({
                  date: toDate
                })}`}
              </div>
            }
            headerContentWrap={true}
          >
            {courses && courses.length ? (
              <BoxTable>
                <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
                  <BoxTableCell>{messages.commonCourse}</BoxTableCell>
                  <BoxTableCell>{messages.commonUsers}</BoxTableCell>
                </BoxTableHeader>

                {courses.map((course, index) => (
                  <BoxTableRow key={course.id}>
                    <BoxTableCell
                      cellBreakpoint={breakpoints.medium}
                      label={messages.commonCourse}
                    >
                      <div className="course">
                        <div className="number">
                          <Avatar
                            backgroundColor={theme.lightGreyDark}
                            fontSize="1.4rem"
                          >
                            {index + 1}
                          </Avatar>
                        </div>

                        <CourseTitleWithInfo
                          linkToCourseAdminPage={true}
                          course={course}
                        >
                          <Owners
                            owners={course.owners}
                            style={{ marginRight: 10 }}
                          />
                        </CourseTitleWithInfo>
                      </div>
                    </BoxTableCell>

                    <BoxTableCell
                      cellBreakpoint={breakpoints.medium}
                      label={messages.commonUsers}
                    >
                      {course.numberOfUsers}
                    </BoxTableCell>
                  </BoxTableRow>
                ))}
              </BoxTable>
            ) : (
              <EmptyIndicator
                icon="book"
                style={{ padding: '120px 50px' }}
                title={messages.commonNoCourses}
              />
            )}
          </Box>

          <style jsx>{`
            .date {
              color: ${theme.textColorLighter};
              font-size: 1.4rem;
              font-weight: 400;
            }
            .course {
              display: flex;
            }
            .number {
              margin-right: 15px;
              margin-top: 5px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default AnalyticsCoursesMostPopular;
